const excludeChildren = (categories, categoryId) => {
  if (!categories.all || !categoryId) return [];

  const resultsIdsToDisplayUpToLevelTwo = categories.resultsToDisplay
    .filter(res => res.level < 2)
    .map(res => res.id);

  return categories.all
    .filter(category =>
    {
      return String(category.id) !== String(categoryId)
        && String(category.motherCategoryId)
        !== String(categoryId)
      && resultsIdsToDisplayUpToLevelTwo.includes(category.id)
    }
    );
};

export default excludeChildren;



// WEBPACK FOOTER //
// ./src/helpers/unileverSales/excludeChildren.js